import NoDataRow from '@/platform/common/components/NoDataRow/NoDataRow';
import { localDate } from '@/platform/lib/utils';
import {
    Badge,
    Button,
    Modal,
    ModalActions,
    ModalContent,
    ModalHeader,
    Table,
    TableBody,
    TableCell,
    TableHeader,
    TableHeaderCell,
    TableRow,
} from '@/platform/ui';
import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import { router, usePage } from '@inertiajs/react';
import { useEffect } from 'react';
import StatusIcon from './StatusIcon';

const ChecksModal = ({ onClose, dgrIdentityId }) => {
    const { auth, dgr_identity: dgrIdentity } = usePage().props;

    const canDownload = auth?.permissions?.includes('download dgr screenshot');

    useEffect(() => {
        router.get(
            `/customers/${auth?.customer?.id}/services/dgr/${dgrIdentityId}/timeline`,
            {},
            {
                preserveState: true,
                preserveScroll: true,
                preserveUrl: true,
                only: ['dgr_identity'],
            }
        );
    }, [dgrIdentityId]);

    return (
        <Modal open={true} onClose={onClose} size='large'>
            <ModalHeader>Doelgroepregister tijdlijn</ModalHeader>
            <ModalContent>
                <Table striped>
                    <TableHeader>
                        <TableRow>
                            <TableHeaderCell>Gecontroleerd op</TableHeaderCell>
                            <TableHeaderCell textAlign='center'>
                                Status
                            </TableHeaderCell>
                            <TableHeaderCell textAlign='center'>
                                Schermafbeelding
                            </TableHeaderCell>
                            <TableHeaderCell textAlign='right'>
                                Type check
                            </TableHeaderCell>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {dgrIdentity?.checks?.length === 0 && (
                            <NoDataRow numberOfColumns={4} />
                        )}

                        {dgrIdentity?.checks?.map(check => (
                            <TableRow key={check.id}>
                                <TableCell>
                                    {localDate(check.checked_at)}
                                </TableCell>
                                <TableCell textAlign='center'>
                                    <StatusIcon status={check.status} />
                                </TableCell>
                                <TableCell textAlign='center'>
                                    {canDownload && check.document_id && (
                                        <Button
                                            as='a'
                                            href={`/dgr-identity-check/${check.id}/screenshot/download`}
                                            target='_blank'
                                            rel='noopener noreferrer'
                                            aria-label='Schermafbeelding downloaden'
                                        >
                                            <ArrowDownTrayIcon className='size-5' />
                                        </Button>
                                    )}
                                </TableCell>
                                <TableCell textAlign='right'>
                                    <Badge
                                        color={check.type_color}
                                        title={check.reason || ''}
                                    >
                                        {check.type_label}
                                    </Badge>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </ModalContent>
            <ModalActions>
                <Button onClick={onClose}>Sluiten</Button>
            </ModalActions>
        </Modal>
    );
};

export default ChecksModal;
